import { PreparedWorkload } from 'features/workload-optimization';

import { useVersionsInfo } from '../../../_hooks/useVersionsInfo';
import { HpaDisableReasons } from '../../../_types';
import { getHpaDisabledReasons } from '../../../_utils';

export const useHpaDisabledReasons = (
  workload?: PreparedWorkload
): HpaDisableReasons => {
  const { isWoopAgentOutdatedForHpa, isCastAgentOutdatedForHpa } =
    useVersionsInfo();
  const hpaDisabledReasons = workload && getHpaDisabledReasons(workload);
  const isDisabled =
    isWoopAgentOutdatedForHpa ||
    isCastAgentOutdatedForHpa ||
    (hpaDisabledReasons &&
      Object.values(hpaDisabledReasons).some((disabled) => disabled));

  if (!workload) {
    return {
      isDisabled: !!isDisabled,
      isWoopAgentOutdatedForHpa,
      isCastAgentOutdatedForHpa,
      isCastware: false,
      typeNotSupported: false,
      hasNativeHpa: false,
      managedByAnnotations: false,
    };
  }

  return {
    isDisabled: !!isDisabled,
    isWoopAgentOutdatedForHpa,
    isCastAgentOutdatedForHpa,
    ...getHpaDisabledReasons(workload),
  };
};
